import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeVi from '@angular/common/locales/vi';
import localeEn from '@angular/common/locales/en';

registerLocaleData(localeVi);
registerLocaleData(localeEn);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
